import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setPaymentVisible } from "../redux/features/paymentSlice";
import PageTitle from "./pageTitle";
import StripeSubscription from "../component/payment/StripeSubscription";

const UpgradeToBat = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const isPaymentVisible = useSelector((state) => state.payment.isPaymentVisible);
    const auth = useSelector((state) => state?.auth?.tokenDetails);
    const UPGRADE_ACCOUNT_TYPE = "upgrade"

    return (
      <React.Fragment>
        <h5 className="pt-100 pl-30 pr-30 text-center">
          Upgrade to BAT account to enjoy free profiles for your children
        </h5>
        <div className="d-flex justify-content-center align-items-start mt-30">
          <div className="d-flex mt-20 mb-20 position-relative">
            <div className="d-flex flex-column align-items-center">
              <button
                className="button payment-btn"
                onClick={() => dispatch(setPaymentVisible(!isPaymentVisible))}>
                {isPaymentVisible
                  ? "Hide Subscription Details"
                  : "Upgrade to BAT account"}
              </button>
              {isPaymentVisible && (
                <div className="mt-20">
                  <StripeSubscription
                    profileId={auth?.id}
                    accountEmail={auth?.email}
                    type={UPGRADE_ACCOUNT_TYPE}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
};

export default UpgradeToBat;
